export function isMac() {
  return /macintosh|mac os x/i.test(navigator.userAgent);
};